import React from "react";
import DashboardPresenter from "./DashboardPresenter";
import NavBar from "../../components/navbar";
import Count from "./components/Count";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { dialog, InfiniteScroll } from "../../nq-component";
import AddWidget from "./components/AddWidget";
import DialogTable from "../../components/DialogTable";
import DeleteWidget from "./components/DeleteWidget";
import FormCollection from "../collection-list/components/FormCollection";
import { updateSchemaUseCase } from "../../usecases/schema/usecases";
import InputFactory from "../../components/InputFactory";
import EditWidget from "./components/EditWidget";
import MyCalendar from "../../components/CalendarCustom";
import MetricsContainer from "./components/Metrics";
import Table from "../../components/Table";
import excludeFields from "./ExcludeField";
import DateRange from "./components/DateRange";

class DashboardPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DashboardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      updateSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      metricsProgress: true,
      status: "New",
      allApplications: [],
      currentDate: new Date().toISOString(),
      startDate: null,
      endDate: null,
      metricsData: {},
    };
  }

  // async componentDidMount() {
  //   const user = await this.getCurrentUser();
  //   const isAdmin = await user.roles.some((role) => role.id === "Admin");
  //   if (!isAdmin) {
  //     return this.navigateTo("/denied");
  //   }

  //   await this.presenter.init();
  //   await this.presenter.getAllApplications();
  //   await this.presenter.getObjects();
  // }

  getCollectionName() {
    return "online_applicants";
  }

  closeDialog() {
    dialog.close();
  }

  onClickAddWidget() {
    const schemas = this.getSchemas();
    dialog.fire({
      html: (
        <AddWidget
          collections={schemas.map((s) => s.collection)}
          onSubmit={(o) => {
            dialog.close();
            this.presenter.onSubmitAddWidget(o);
          }}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickDeleteWidget() {
    const schemas = this.getSchemas();
    dialog.fire({
      html: (
        <DeleteWidget
          objects={this.state.objects}
          collections={schemas.map((s) => s.collection)}
          onSubmit={(i) => {
            dialog.close();
            this.presenter.onSubmitDelete(i);
          }}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickEditWidget() {
    dialog.fire({
      html: (
        <EditWidget
          widgets={this.getObjects()}
          onSubmit={(i) => {
            dialog.close();
            this.presenter.onSubmitDelete(i);
          }}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onCLickWidget(object) {
    const schema = this.getSchema(object.collection);
    dialog.fire({
      html: (
        <DialogTable
          title={object.collection}
          where={object.where}
          schema={schema}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickEditCollection() {
    const schema = this.getSchema(this.getCollectionName());
    dialog.fire({
      html: (
        <FormCollection
          schema={schema}
          onSubmit={(s) => this.presenter.onSubmitEditCollection(s)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  getObjects() {
    this.presenter.init();
    Promise.all([this.presenter.getObjects()]);
  }

  getAllObjects() {
    this.presenter.init();
    Promise.all([
      this.presenter.getObjects(),
      this.presenter.getAllApplications(),
    ]);
  }

  onClickStatus(status) {
    this.setState({ status }, () => {
      this.getObjects();
    });
  }

  onChangeDate(value, field) {
    this.setState({ [field]: value });
  }

  clickData(object) {
    const applicationType = object.interviewCoordinator;
    const id = object.id;

    this.navigateTo(`/application-form/${applicationType}/${id}`);
  }

  render() {
    const {
      objects,
      selected,
      progress,
      count,
      allApplications,
      metricsProgress,
      metricsData,
    } = this.state;
    const where = this.state.where;
    const schema = this.getSchema("online_applicants");
    if (!schema) return null;
    const user = this.getCurrentUser();

    console.warn("userDetails", user);

    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">Dashboard</h1>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center flex-lg-row flex-column btn mb-2">
                  <DateRange
                    onApply={this.getAllObjects.bind(this)}
                    onChange={this.onChangeDate.bind(this)}
                  />
                </div>
                {/* {progress ? <Progress /> : <ReportTable objects={reports} />} */}
              </div>

              <div className="d-flex w-full">
                <MetricsContainer
                  progress={metricsProgress}
                  objects={allApplications}
                  metricsData={metricsData}
                  onClickStatus={this.onClickStatus.bind(this)}
                />
              </div>

              <div className="d-flex flex-column gap-1 my-2">
                <p
                  className="m-0 fw-bold align-self-start"
                  style={{ color: `#D18237` }}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
                <div className="d-flex gap-2">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                </div>
              </div>

              <div>
                <Table
                  fields={schema.fields}
                  onClick={this.clickData.bind(this)}
                  objects={objects}
                  excludeFields={Object.keys(schema.fields).reduce(
                    (acc, key) => {
                      const options = schema.fields[key];
                      if (excludeFields.includes(key)) acc.push(key);
                      if (options.read === false) acc.push(key);
                      switch (options._type || options.type) {
                        case "Relation":
                        case "Array":
                        case "Object":
                        case "File":
                          acc.push(key);
                          break;
                        default:
                      }
                      return acc;
                    },
                    excludeFields
                  )}
                  selected={selected}
                  onSelect={this.onSelect.bind(this)}
                  onSelectAll={this.onSelectAll.bind(this)}
                  progress={progress}
                  // onClickItem={this.onClickItem.bind(this)}
                  onSort={this.onClickSort.bind(this)}
                  className="mt-1"
                />
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default DashboardPage;
